import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const r = "address";
class n extends e {
  /**
   * Get list of all available country codes, including their translated names for the given language.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/address/country/{lang}`
   *
   * @param {string} lang - Language for which to translate `label` values to.
   * @returns {Promise<GetCountryReceivedData>} A promise resolving to a list of objects containing country code (`value`) and their translated name (`label`).
   */
  getCountry = async (s) => {
    const { data: t } = await this.get(
      `${r}/country/${s}`
    );
    return t;
  };
}
export {
  n as Address
};
